import Picture, { IPicture, IPictureApiModel } from './Picture.model';

export interface IPictureEquipment {
  id: number;
  pictureId: string;
  picture: IPicture;
}

export interface IPictureEquipmentApiModel {
  id: number;
  pictureId: string;
  picture: IPictureApiModel;
}

export default class PictureEquipment implements IPictureEquipment {
  public readonly id: number;

  public readonly pictureId: string;

  public readonly picture: IPicture;

  constructor(id: number, pictureId: string, picture: IPicture) {
    this.id = id;
    this.pictureId = pictureId;
    this.picture = picture;
  }

  static fromApiModel(apiModel: IPictureEquipmentApiModel) {
    const { id, pictureId } = apiModel;

    const picture = Picture.fromApiModel(apiModel.picture);
    return new PictureEquipment(id, pictureId, picture);
  }

  static arrayFromApiModel(arrayApiModel: IPictureEquipmentApiModel[]) {
    const array = arrayApiModel.map(apiModel =>
      PictureEquipment.fromApiModel(apiModel),
    );

    return array;
  }
}
